import React from "react";
import CohortCard from "./CohortCard";
import { useDispatch } from "react-redux";
import { setSelectedCohort } from "../../../../rtk-query/features/cohort/cohortSlice";
import exportimages from "../../../../assets/images/exportImages";
import { fnCheckDollarUnits } from "../../report/widget/widgetsCommonFunction";

const SuggestedCohort = ({ cohortList }) => {
  const dispatch = useDispatch();
  return (
    <div className="list-cohort flex-start">
      {cohortList?.length > 0 ? (
        cohortList?.map((cohort) => {
          const cohort_Result = cohort?.cohort_Result;
          const filter_Json = cohort?.filter_Json;
          const { score: minAssetSize, unit: minAssetSizeUnit } =
            fnCheckDollarUnits(Number(filter_Json?.assets?.min) ?? 0);
          const { score: maxAssetSize, unit: maxAssetSizeUnit } =
            fnCheckDollarUnits(Number(filter_Json?.assets?.max) ?? 0);

          return (
            cohort?.cohort_Type === 1 && (
              <div
                key={cohort?.uid}
                onClick={() => {
                  dispatch(setSelectedCohort(cohort));
                }}
                className="w-100"
              >
                <CohortCard
                  uid={cohort?.uid}
                  title={cohort?.name}
                  subtitle={cohort?.description}
                  range={`$${minAssetSize?.toFixed(2)}${minAssetSizeUnit} – $${maxAssetSize?.toFixed(2)}${maxAssetSizeUnit}`}
                  // range={`$${filter_Json?.assets?.min} – $${filter_Json?.assets?.max}`}
                  institutions={cohort_Result?.institution_count}
                  avg={cohort_Result?.cohort_avg}
                  percentile={cohort_Result?.percentile}
                />
              </div>
            )
          );
        })
      ) : (
        <div className="message-container">
          <div className="message">
            <div className="no_cohort">
              <img alt="icon" src={exportimages.no_cohort} />
            </div>
            <div className="message">No Suggested Cohorts Yet</div>
            <div className="desc">System has not suggested any cohort.</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuggestedCohort;
